import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../hooks';

export const AdminPanelIndexRedirect = () => {
    const role = useAppSelector((state) => state.profileReducer.role);

    if (role === 'onboarding_representative') {
        return <Navigate to="suppliers" replace />;
    }
    if (role === 'super_admin') {
        return <Navigate to="users" replace />;
    }

    return null;
};
